import { Component, OnInit } from '@angular/core';

import { Campus } from 'src/app/core/models/api/campus.model';
import { CampusService } from 'src/app/core/services/api/campus.service';

@Component({
    selector: 'app-cookies-policy',
    templateUrl: './cookies-policy.component.html',
    styleUrls: ['./cookies-policy.component.scss']
})
export class CookiesPolicyComponent implements OnInit {

    public campus: Campus;
    public webResourceId: string = "cookies-policy-page";

    constructor(private campusService: CampusService) { }

    ngOnInit() {

        this.campus = this.campusService.campusActive;

    }

}
